import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import {
  AppInstrumentationTooltip,
  AppInstrumentationTooltipProps
} from '../../../components/servers-grid/app-instrumentation-tooltip'

function AppInstrumentationTooltipBridge({
  applicationName,
  placement
}: AppInstrumentationTooltipProps) {
  if (typeof applicationName !== 'string') {
    throw new Error('applicationName is a required prop and must be a string')
  }
  return (
    <AppInstrumentationTooltip
      applicationName={applicationName}
      placement={placement}
    />
  )
}

export const reactAppInstrumentationTooltip = createNgReactBridgeDirective(
  'reactAppInstrumentationTooltip',
  [],
  AppInstrumentationTooltipBridge,
  ['applicationName', 'placement']
)
